import ApiService from '../common/api.service';

import {
  FETCH_VACATIONS,
  ADD_VACATION, REMOVE_VACATION,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_VACATIONS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/vacaciones', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [ADD_VACATION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/agregar_vacacion', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_VACATION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/eliminar_vacacion', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
